import '.f{width:100%;}.ssr-plugin'
import '.ad{max-width:440px;}.ssr-plugin'
import '.p{margin:0 auto;}.ssr-plugin'
import '.ae{border:1px solid #262626;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.af{align-items:start;}.ssr-plugin'
import '.ag{justify-content:flex-start;}.ssr-plugin'
import '.ah{padding:32px;}.ssr-plugin'
import '.ai{margin-bottom:12px;}.ssr-plugin'
import '.aj{border-top:1px solid #262626;}.ssr-plugin'
import '.ak{position:fixed;}.ssr-plugin'
import '.al{inset:0px;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.b{height:100vh;}.ssr-plugin'
import '.am{overflow:hidden;}.ssr-plugin'
import { styled } from 'inlines'
import { Button } from '../components/Button'
import { useEffect, useState } from 'react'
import { Spinner } from '../components/Spinner'
import { useTheme } from '../providers/useTheme'

const Loading = () => {
  const [isDown, setIsDown] = useState(false)
  const [isSlow, setIsSlow] = useState(false)
  const { colors } = useTheme()

  useEffect(() => {
    const timer1 = setTimeout(() => setIsDown(true), 15e3)
    const timer2 = setTimeout(() => setIsSlow(true), 3e3)
    return () => {
      clearTimeout(timer1)
      clearTimeout(timer2)
    }
  }, [])

  return isDown ? (
    <styled.div className="f ad p ae"
      style={{
        '@media only screen and (max-width: 744px)': { border: 'none' },
      }}
    >
      <styled.div className="a i af ag ah"
        style={{
          color: colors.textPrimary,
          '@media only screen and (max-width: 744px)': {
            padding: '16px',
          },
        }}
      >
        <h3 className="ai">Unable to Connect</h3>
        <p className="ai">
          It looks like your connection to our service is currently being
          interrupted. This can happen if your network or firewall settings are
          blocking the connection, or if your internet access is unstable.
        </p>
        <p>
          Please check your network settings, firewall, or internet connection,
          and then try again. If the issue persists, rest assured we're
          monitoring closely to ensure smooth service for all our users.
        </p>
      </styled.div>
      <styled.div className="ah aj"
        style={{
          '@media only screen and (max-width: 744px)': {
            padding: '16px',
            border: 'none',
          },
        }}
      >
        <Button
          id="infra-down-reload-page"
          on={{
            click: () => location.reload(),
          }}
          style={{ color: colors.textPrimary }}
        >
          Reload page
        </Button>
      </styled.div>
    </styled.div>
  ) : isSlow ? (
    <Spinner />
  ) : null
}

export const InfraDownPage = ({ loading }) => {
  if (!loading) {
    return null
  }

  return (
    <div className="ak al a d c b am"
    >
      <Loading />
    </div>
  )
}
